<template>

  <AbortStateTemplate
      :headline="headline"
      :message="abortMessage"
      :teaserCards="teaserCardsData"
  />
</template>

  <script>
  import teaserCardsData from "@/data/teaserData";
  import AbortStateTemplate from "@/components/abortStates/AbortStateTemplate.vue";

  export default {
    name: 'StateAbortHeatingLocation',
    components: {
      AbortStateTemplate,
    },
    data() {
      return {
        abortMessage:
            "Da Ihre Heizung sich im Dach- oder Obergeschoss befindet, ist es uns leider nicht möglich, eine Wärmepumpe zu installieren. Das hängt mit den räumlichen Gegebenheiten zusammen.",
          teaserCardsData
    };
    },
  }
  </script>

